import {
  Component,
  ComponentFactoryResolver,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import {ModalConfig} from './modal.config';

import {ModalService} from './modal.service';

@Component({
  selector: 'modal',
  template: '<div class="block window"><div #content></div></div>',
  styleUrls: ['modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit, OnDestroy {

  element: any;
  @ViewChild('content', {read: ViewContainerRef}) content: ViewContainerRef;

  constructor(private modalService: ModalService,
              private el: ElementRef,
              private componentFactoryResolver: ComponentFactoryResolver) {
    this.element = el.nativeElement;
  }

  ngOnInit(): void {
    document.body.appendChild(this.element);

    this.element.addEventListener('click', el => {
      if (el.target.nodeName.toLowerCase() === 'modal') {
        this.close();
      }
    });

    this.modalService.set(this);
  }

  ngOnDestroy(): void {
    this.element.remove();
  }

  open(config: ModalConfig): void {
    this.content.clear();

    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(config.component);
    this.content.createComponent(componentFactory);

    document.body.classList.add('open');
  }

  close(): void {
    document.body.classList.remove('open');
  }
}
